exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.confirm-btn[data-v-2ca81490]{width:100%\n}\n", "", {"version":3,"sources":["/home/jenkins/agent/workspace/sunpay-system-manager/src/components/device/paybank-vcb.vue"],"names":[],"mappings":";AACA,8BAA8B,UAAU;CACvC","file":"paybank-vcb.vue","sourcesContent":["\n.confirm-btn[data-v-2ca81490]{width:100%\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2ca81490","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/device/paybank-vcb.vue
// module id = oo5W
// module chunks = 8